import { render, staticRenderFns } from "./BBLazy.vue?vue&type=template&id=74d0b144&"
import script from "./BBLazy.vue?vue&type=script&lang=ts&"
export * from "./BBLazy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports